import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Arrays from '../../../utils/Arrays';
import CompaniesTabRow from './CompaniesTabRow';
import { PsTable } from '../../table/PsTable';

export default class CompaniesTabTable extends React.Component {

    buildHeader() {
        let checkedAll = false;
        if ( this.props.data || this.props.data.length > 0 ) {
            const nonSelectedElements = _.filter(this.props.data, element => !Arrays.contains(this.props.selectedIds, element.id));
            checkedAll = nonSelectedElements.length === 0;
        }
        return CompaniesTabRow.renderHead('COMPANIES_TAB_TABLE',
            this.props.selectedIds !== null ? {
                text: this.props.selectAllText,
                checked: checkedAll,
                onChecked: (checked) => this.props.actionSelectAll(this.props.data, checked),
            } : null);
    }

    render() {

        if ( this.props.error ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{this.props.error}</h3>
                </section>
            );
        }
        if ( !this.props.data || this.props.data.length === 0 ) {
            return null;
        }
        return (
            <PsTable headings={this.buildHeader()}>
                {
                    _.map(this.props.data, (object, i) =>
                        <CompaniesTabRow
                            id={this.props.id}
                            hideOutsource={this.props.hideOutsource}
                            key={i}
                            company={object}
                            selectedIds={this.props.selectedIds}
                            actionSelectItem={this.props.actionSelectItem}
                            selectText={this.props.selectText}
                            action={this.props.action}
                            actionText={this.props.actionText}
                        />,
                    )
                }
            </PsTable>
        );
    }

}

CompaniesTabTable.propTypes = {
    id: PropTypes.string.isRequired,
    data: PropTypes.any,
    error: PropTypes.string,

    selectedIds: PropTypes.array,
    actionSelectItem: PropTypes.func,
    actionSelectAll: PropTypes.func,
    selectText: PropTypes.string,
    selectAllText: PropTypes.string,
    action: PropTypes.any,
    actionText: PropTypes.string,
};

CompaniesTabTable.defaultProps = {
    selectedIds: null,
    actionSelectItem: () => {},
    actionSelectAll: () => {},
};



// WEBPACK FOOTER //
// ./src/app/shared/components/tabs/companies/CompaniesTabTable.jsx